import { Consumer, createConsumer } from "@rails/actioncable";
import { Constants } from "@socialcoach/services";

const CABLE_PATH = `${Constants.API_URL}/bedrock/cable`;

let consumer: Consumer | null = null;

/** One shared consumer per page, created lazily so SSR never opens a socket. */
export function getCableConsumer(): Consumer {
  if (!consumer) {
    consumer = createConsumer(CABLE_PATH);
  }
  return consumer;
}

/** Test-only escape hatch so each test starts from a fresh consumer. */
export function resetCableConsumer(): void {
  consumer = null;
}
